import { EventReceiverInputDto } from '@/services/codegen-welfare';
import * as Sentry from '@sentry/react';

const EVENT_RECIVE_URL = window._env_.VITE_EVENT_R_URL;

export function sendEventReciever(event: EventReceiverInputDto) {
  try {
    fetch(EVENT_RECIVE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Special-Header': window._env_.VITE_EVENT_R_TOKEN,
      },
      body: JSON.stringify(event),
      keepalive: true,
    });
  } catch (err) {
    Sentry.captureException(err);
  }
}
